module.exports = __webpack_public_path__ + "static/img/texture.abcece2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/coach/texture.svg
// module id = Zm3u
// module chunks = 35